import React,{useEffect} from 'react';
import UScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import * as Icon from 'ubs-icons'
import { COLOR } from 'ubs-framework/v2/common/constant';
import {sendData} from "../../../store/actions";
import {useDispatch} from "react-redux";

const UAccountSidebar = (props) => {
    const {list, innerListVisible, onClick, onInnerClick, active, inner_active, isSubMenu} = props;
    const dispatch = useDispatch();

    useEffect(() => {
        sendData(dispatch, 'getWorkspaceList', {requirePlanDetails: true});
    }, []);

    return (
        <React.Fragment>
            <UScrollBar>
                <ul className="u_account-sidebar u_active">
                    {list.map((data, i) => {
                        const isActiveRoute = active === data.route;
                        const hasInnerMenu = data?.inner_menu?.length >= 1;
                        const isInnerMenuActive = isActiveRoute && innerListVisible;

                        return (
                            data?.isAccess && (
                                <li
                                    className={`${isActiveRoute ? 'u_active-menu' : ''} ${hasInnerMenu ? 'u_inner-menu' : ''} ${isInnerMenuActive ? 'u_active-innermenu' : ''}        `}
                                    key={i}
                                    onClick={(e) => onClick(data, i, e)}
                                >
                                    {data.name === 'Ess/Non-Ess Policy' && data.essCount !== undefined ? (
                                        <div className="u_non-ess-box">
                                            <div className="u_neb-top u_flex-align">
                                                {data.icon}
                                                <span className="u_menu-name u_ml-8">{data.name}</span>
                                            </div>
                                            <div className="u_neb-bottom u_flex u_align-center">
                                                <div className="u_neb-item">
                                                    <p>ESS</p>
                                                    <h6>{data.essCount}</h6>
                                                </div>
                                                <div className="u_neb-divider" />
                                                <div className="u_neb-item">
                                                    <p>Non-ESS</p>
                                                    <h6>{data.nonEssCount}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="u_menu-item u_flex-align u_content-between">
                                            <div className={"u_flex-align"}>
                                                {data.icon}
                                                <span className="u_menu-name u_ml-8">{data.name}</span>
                                            </div>
                                            {hasInnerMenu && <div className={`u_flex-align u_arrow ${isInnerMenuActive ? 'u_arrow-expanded' : ''}`}>
                                                <Icon.DownArrow size={2} fill={isActiveRoute ? COLOR.u_blue : COLOR.u_icon_bg}/>
                                            </div>}
                                        </div>
                                    )}

                                    {isInnerMenuActive && hasInnerMenu && (
                                        <ul className="u_menu-item-list">
                                            {data.inner_menu.map((menu, j) =>
                                                    menu?.isAccess && (
                                                        <li
                                                            onClick={(e) => onInnerClick(e, menu, data.route)}
                                                            className={`${menu.route === inner_active ? 'u_active-inner-menu' : ''}`}
                                                            key={j}
                                                        >
                                                            <span className="u_menu-name">{menu.name}</span>
                                                        </li>
                                                    )
                                            )}
                                        </ul>
                                    )}
                                </li>
                            )
                        );
                    })}
                </ul>
            </UScrollBar>
        </React.Fragment>
    );
};

export default UAccountSidebar;